import { CheckedChangedEventArgs as CheckedChangedEventArgs_internal } from "./CheckedChangedEventArgs";
import { ensureBool } from "igniteui-react-core";
var IgrCheckedChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrCheckedChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrCheckedChangedEventArgs.prototype.createImplementation = function () {
        return new CheckedChangedEventArgs_internal();
    };
    Object.defineProperty(IgrCheckedChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrCheckedChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrCheckedChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrCheckedChangedEventArgs.prototype, "index", {
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrCheckedChangedEventArgs.prototype, "isChecked", {
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = ensureBool(v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrCheckedChangedEventArgs;
}());
export { IgrCheckedChangedEventArgs };
//# sourceMappingURL=igr-checked-changed-event-args.js.map
